module.exports = __webpack_public_path__ + "img/icon_industrial_en.324d0669.png";